import { pickBy } from 'lodash'
import { Patient } from '@babylon/consumer-api/types'
import { userFieldsToStore } from '@/constants'

const filterUserObject = (patient: Patient) =>
  pickBy(patient, (v, key) => userFieldsToStore.indexOf(key) > -1)

export default filterUserObject
